import React from 'react';
import listAmIcon from '../../imgs/list-am.png';

interface Props {
    size?: number;
    className?: string;
}

// Официальный логотип list.am (синий «клевер»).
const ListAmLogo: React.FC<Props> = ({ size = 18, className }) => (
    <img
        src={listAmIcon}
        alt="list.am"
        className={className}
        width={size}
        height={size}
        style={{ verticalAlign: 'middle', flexShrink: 0, borderRadius: 4 }}
    />
);

export default ListAmLogo;
